import React from 'react';
import * as _ from 'lodash';
import { CCUS_JOB_CODE } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormDropdownClearButton } from '../../CommonFormComponents';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';

/**
 * 職種ドロップダウンリスト
 *
 * @export
 * @class JobCategoryDropdown
 * @extends {React.Component}
 * @param title {string} 表示名
 * @param placeholder {string} プレースホルダー名
 * @param large_code {string} 初期値-大分類名
 * @param small_code {string} 初期値-小分類名
 * @param worker_job_id {string} 初期値-作業員職種ID
 * @param other_job_names {object} 自由入力された職種リスト
 * @param jobCategoriesList {object} 技能職種マスタ
 * @param setIdentifier {any} setファンクションで選択したデータを識別するための値 (必須ではない)
 * @param set {function} 値選択処理
 */
export class JobCategoryDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allLoaded: false,
      opened: false,
      condition: {
        name: '',
      },
      optionsAll: [], // 項目全体リスト
      options: [], // 選択項目リスト
      selected_code_large: null, // 選択職種コード（大分類）
      selected_code_small: null, // 選択職種コード（小分類）
      selected_worker_job_id: undefined, // 選択作業員職種ID
      temporarySelected_code_large: null, // 選択職種コードtemp（大分類）
      temporarySelected_code_small: null, // 選択職種コードtemp（小分類）
      temporarySelected_worker_job_id: undefined, // 選択作業員職種ID
      isLoading: true, // ロード中フラグ
      disabled: props.disabled || false, //非活性フラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    const options = this.getJobCategoriesOptions(this.props.other_job_names);
    this.setState({
      optionsAll: options,
      options,
      isLoading: false,
      loaded: this.props.loaded || false,
      selected_code_large: this.props.large_code,
      selected_code_small: this.props.small_code,
      selected_worker_job_id: this.props.worker_job_id || undefined,
    });
  }

  // コンポーネントがアンマウントされたときは
  // documentのイベントを除去
  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  // componentWillReceivePropsの使用は非推奨
  // +reactの17バージョン以降廃止の予定なので、
  // 代替処理としてgetDerivedStateFromPropsを使う。
  static getDerivedStateFromProps(nextProps, prevState) {
    let resultState = {};
    resultState.disabled = nextProps.disabled || false;
    // 初期値が設定されていた場合はselectedへセット
    if (
      nextProps.large_code !== prevState.selected_code_large ||
      nextProps.small_code !== prevState.selected_code_small ||
      nextProps.worker_job_id !== prevState.selected_worker_job_id
    ) {
      resultState.selected_code_large = nextProps.large_code;
      resultState.selected_code_small = nextProps.small_code;
      resultState.selected_worker_job_id = nextProps.worker_job_id || undefined;
      resultState.temporarySelected_code_large = nextProps.large_code || null;
      resultState.temporarySelected_code_small = nextProps.small_code || null;
      resultState.temporarySelected_worker_job_id =
        nextProps.worker_job_id || undefined;
    }
    return resultState;
  }

  componentDidUpdate(prevProps) {
    // ソートされてother_job_namesが変わった場合に再セットする
    if (!_.isEqual(this.props.other_job_names, prevProps.other_job_names)) {
      const options = this.getJobCategoriesOptions(this.props.other_job_names);
      this.setState({
        optionsAll: options,
        options,
        loaded: this.props.loaded,
        isLoading: false,
        condition: { name: '' },
      });
    }

    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  /**
   * CCUS技能職種マスタの「その他 - その他」に、作業員毎に自由入力した職種を、
   * それぞれ全角スペース(\u3000)で連結して、追加したリストを返す。
   * @param {Array} other_job_names 作業員職種に自由入力した職種
   * @return {Array} 作業員職種プルダウンリスト
   */
  getJobCategoriesOptions = other_job_names => {
    if (_.isEmpty(other_job_names)) {
      return this.props.jobCategoriesList;
    }
    let options = [];
    _.each(this.props.jobCategoriesList, item => {
      let option = _.cloneDeep(item);
      option.worker_job_id = undefined;
      options.push(option);
      if (
        item.ccus_job_code_l === CCUS_JOB_CODE.SONOTA_SONOTA.LARGE_CLASS_CODE &&
        item.ccus_job_code_s === CCUS_JOB_CODE.SONOTA_SONOTA.SMALL_CLASS_CODE
      ) {
        let other_option = null;
        _.each(other_job_names, other_item => {
          other_option = _.cloneDeep(item);
          other_option.at_time_small_job_name = `${
            other_option.at_time_small_job_name
          }\u3000\u3000\u3000\u3000${other_item.other_job_name}`;
          other_option.worker_job_id = other_item.worker_job_id;
          options.push(other_option);
        });
      }
    });
    return options;
  };

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  handleOpen = e => {
    // 初期化
    let {
      opened,
      selected_code_large,
      selected_code_small,
      selected_worker_job_id,
      disabled,
    } = {
      ...this.state,
    };
    if (opened === false && disabled === false) {
      const targetPosition = _.isFunction(this.props.jumpToShowDropdown)
        ? e.target.getBoundingClientRect()
        : null;
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState(
        {
          opened: true,
          temporarySelected_code_large: selected_code_large,
          temporarySelected_code_small: selected_code_small,
          temporarySelected_worker_job_id: selected_worker_job_id,
        },
        () => {
          if (_.isFunction(this.props.jumpToShowDropdown)) {
            this.props.jumpToShowDropdown(targetPosition, 38); // jumpToShowDropdownに選択したドロップダウンの位置情報と職種ドロップダウンの起点を与えてスクロール位置を指定する
          }
        }
      );
    } else {
      this.setState({ opened: false });
    }
  };

  setCondition = e => {
    const name = e.target.value;
    this.setState(
      prevState => ({
        condition: { ...prevState.condition, name },
      }),
      () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.search();
        }, 1000);
      }
    );
  };

  search = () => {
    const searchList = this.state.optionsAll.filter(item => {
      return (
        item.at_time_large_job_name.search(this.state.condition.name) !== -1 ||
        item.at_time_small_job_name.search(this.state.condition.name) !== -1
      );
    });
    this.setState({ options: searchList });
  };

  /**
   * 指定した職種を選択状態にする
   *
   * @param {number} largeCode：職種大分類コード
   * @param {number} smallCode：職種小分類コード
   * @param {number} worker_job_id：作業員職種ID
   * */
  handleSelectedRow = (largeCode, smallCode, worker_job_id) => {
    this.setState(
      {
        temporarySelected_code_large: largeCode,
        temporarySelected_code_small: smallCode,
        temporarySelected_worker_job_id: worker_job_id,
      },
      () => {
        this.setValue(largeCode, smallCode, worker_job_id);
      }
    );
  };

  clearSelectedRow = () => {
    this.setState(
      {
        temporarySelected_code_large: null,
        temporarySelected_code_small: null,
        temporarySelected_worker_job_id: null,
      },
      () => {
        this.setValue(null, null, null);
      }
    );
  };

  setValue = (largeCode, smallCode, worker_job_id) => {
    let { selected_code_large, selected_code_small, selected_worker_job_id } = {
      ...this.state,
    };
    // temp情報をselect~に入れる
    selected_code_large = largeCode;
    selected_code_small = smallCode;
    selected_worker_job_id = worker_job_id;

    this.setState({
      selected_code_large,
      selected_code_small,
      selected_worker_job_id,
      opened: false,
    });
    this.props.set(
      selected_code_large,
      selected_code_small,
      selected_worker_job_id,
      this.props.setIdentifier
    );
  };

  render() {
    const scrollFrameHeight = document.getElementById(
      'job-and-position-scroll-frame'
    ).clientHeight;

    const getName = () => {
      let name = `${this.props.title}を選択`;
      let option = _.find(this.state.optionsAll, {
        ccus_job_code_l: this.state.selected_code_large,
        ccus_job_code_s: this.state.selected_code_small,
        worker_job_id: this.state.selected_worker_job_id,
      });
      if (!option) {
        // other_job_namesがない場合は、worker_job_idがないので、再検索する
        option = _.find(this.state.optionsAll, {
          ccus_job_code_l: this.state.selected_code_large,
          ccus_job_code_s: this.state.selected_code_small,
        });
      }
      if (option) {
        const large_name = option.at_time_large_job_name;
        const small_name = option.at_time_small_job_name;
        name = `${large_name} - ${small_name}`;
      }
      return name;
    };

    return (
      <div className='job-category__element'>
        <div
          id='form-dropdown'
          className='edit-dialog-modal-dropdown dropdown-multi-select'
        >
          {
            <div ref={this.parent}>
              <div className='dropdown-multi-select__header'>
                <div
                  id='form-dropdown-btn'
                  className={
                    this.state.disabled
                      ? 'dropdown-select disabled'
                      : 'dropdown-select'
                  }
                  onClick={this.handleOpen}
                >
                  <span
                    className={
                      this.state.disabled
                        ? 'dropdown-select__txt disabled'
                        : 'dropdown-select__txt'
                    }
                  >
                    {getName()}
                  </span>
                </div>
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='modal-dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    {this.props.isOptional && (
                      <div className='dropdown-single-select__item'>
                        <FormDropdownClearButton
                          onClick={this.clearSelectedRow}
                        />
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                        style={{ height: scrollFrameHeight - 120 }} // 計算結果がドロップダウンの高さ（ドロップダウン位置から枠内終端付近まで）
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <SelectableOption
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected_code_large ===
                                  option.ccus_job_code_l &&
                                this.state.temporarySelected_code_small ===
                                  option.ccus_job_code_s &&
                                this.state.temporarySelected_worker_job_id ===
                                  option.worker_job_id
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                            />
                          ))}
                        </ul>
                      </div>
                    </div>
                    {/* <div className='dropdown-multi-select__footer'>
                      <button className='btn--sm--stay' onClick={this.setValue}>
                        {messageUtility.getMessage('I-000-091')}
                      </button>
                    </div> */}
                  </div>
                </div>
              )}
            </div>
          }
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='single-select__item'>
    <label
      className='radio'
      htmlFor={`single-job-category-code-${option.ccus_job_code_l}-${
        option.ccus_job_code_s
      }-${option.worker_job_id}-${targetId}`}
    >
      <input
        id={`single-job-category-code-${option.ccus_job_code_l}-${
          option.ccus_job_code_s
        }-${option.worker_job_id}-${targetId}`}
        type='radio'
        checked={checked}
        onClick={() =>
          handleSelectedRow(
            option.ccus_job_code_l,
            option.ccus_job_code_s,
            option.worker_job_id
          )
        }
      />
      <RadioButtonIcon className='icon--1_6x' />
      <span className='single-select__label-text'>
        {`${option.at_time_large_job_name} - ${option.at_time_small_job_name}`}
      </span>
    </label>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/JobCategory.jsx